
import { z } from "zod";

export const goalsSchema = z.object({
  selectedGoals: z.array(z.string()).optional(),
  customGoal: z.string().optional(),
}).refine(
  (data) => (data.selectedGoals && data.selectedGoals.length > 0) || (data.customGoal && data.customGoal.trim().length > 0),
  { message: "Please select at least one goal or provide a custom goal" }
);

export const budgetSchema = z.object({
  budgetBand: z.string().refine((val) => ["under-1k", "1k-3k", "3k-10k", "10k-30k", "30k-plus"].includes(val), {
    message: "Please select a budget range",
  }),
});

export const timelineSchema = z.object({
  startMonth: z.string().min(1, "Start month is required"),
  urgency: z.string().refine((val) => ["flexible", "soon", "asap"].includes(val), {
    message: "Please select urgency level",
  }),
  milestones: z.string().optional(),
});

export const channelsSchema = z.object({
  selectedChannels: z.array(z.string()).optional(),
  otherChannel: z.string().optional(),
}).refine(
  (data) => (data.selectedChannels && data.selectedChannels.length > 0) || (data.otherChannel && data.otherChannel.trim().length > 0),
  { message: "Please select at least one channel or specify other" }
);

export const uploadsSchema = z.object({
  files: z.array(z.instanceof(File)).optional(),
});

export const clientOnboardingSchema = z.object({
  goals: goalsSchema,
  budget: budgetSchema,
  timeline: timelineSchema,
  channels: channelsSchema,
  uploads: uploadsSchema,
});

export type ClientOnboardingData = z.infer<typeof clientOnboardingSchema>;

export const GOAL_OPTIONS = [
  "Increase brand awareness",
  "Generate leads",
  "Drive website traffic",
  "Boost sales",
  "Improve customer retention",
  "Launch new product",
];

export const BUDGET_OPTIONS = [
  { value: "under-1k", label: "Under $1,000/mo" },
  { value: "1k-3k", label: "$1,000 - $3,000/mo" },
  { value: "3k-10k", label: "$3,000 - $10,000/mo" },
  { value: "10k-30k", label: "$10,000 - $30,000/mo" },
  { value: "30k-plus", label: "$30,000+/mo" },
];

export const URGENCY_OPTIONS = [
  { value: "flexible", label: "Flexible timeline" },
  { value: "soon", label: "Need to start soon" },
  { value: "asap", label: "Need to start ASAP" },
];

export const CHANNEL_OPTIONS = [
  "Meta (Facebook/Instagram)",
  "Google Ads",
  "TikTok",
  "LinkedIn",
  "SEO",
  "Email Marketing",
];
